module.exports = __webpack_public_path__ + "media/img/corporate/social-media-push-a466218d31d78bdc50a4f0b57115f25e.svg";